App.controller('setupSharedCtrl', ($rootScope, $scope, Provider, Operatory, NgTableParams) => {
  $scope.search_member_params = {}
  $scope.members_loading = true
  $scope.load_init = false

  $scope.memberIsOperatory = () => {
    return $scope.location && $scope.location.map_by_operatory && $scope.location.appt_types_map_by_operatory
  }

  $scope.memberIsProvider = () => {
    return $scope.location && (!$scope.location.map_by_operatory || !$scope.location.appt_types_map_by_operatory)
  }

  $scope.memberById = (id) => {
    return $scope.membersTableParams.data.find((member) => id === member.id)
  }

  // Members (providers or operatories depending on location setting)
  $scope.membersTableParams = new NgTableParams({}, {
    getData(tparams) {
      if(!$scope.load_init) {
        $scope.load_init = true
        return
      }
      $scope.members_loading = true
      search_opts = {
        location_id: $rootScope.location.id,
        page: tparams.page(),
        per_page: tparams.count()
      }

      if($rootScope.embedded) {
        search_opts.include_inactive = true
      }

      search_params = _.extend(search_opts, $scope.search_member_params)
      if(!tparams.providers_only && $scope.memberIsOperatory()){
        resp = Operatory.$search(search_params)
      } else {
        resp = Provider.$search(search_params)
      }
      return resp.$promise.then(data => {
        if(!resp.$response || !resp.$response.data) { return }

        $scope.members_total_count = resp.$response.data.count
        if(resp.$response && resp.$response.data && $scope.members_total_count){
          tparams.total($scope.members_total_count)
        }
        $scope.members = resp.$response.data.data
        if (tparams.onSuccess) {
          tparams.onSuccess()
        }
        $scope.members_loading = false

        return $scope.members
      })
    }
  })

  loadMembers = (onSuccess, providers_only = false) => {
    $scope.membersTableParams.providers_only = providers_only
    $scope.membersTableParams.onSuccess = onSuccess
    $scope.membersTableParams.reload()
  }

  $scope.$watch('search_member_params', (nv,ov) => {
    if(nv != ov && (nv.search_name && nv.search_name.length > 2 || !nv.search_name || !nv.search_name.length)){
      $scope.membersTableParams.page(1)
      $scope.membersTableParams.reload()
    }
  }, true)

  $scope.$on('loc_change', () => {
    $scope.membersTableParams.page(1)
  })
})
